import { List, Record } from 'immutable';
import { ReadonlyRecord } from '@bimser/core';
import { ActionItem, ActionItemFactoryFromJS, IActionItem } from './IActionItem';

export interface IBaseRuleEdit {
	id: string;
	name: string;
}

export interface IRuleEdit extends IBaseRuleEdit {
	actions: Array<IActionItem>;
}

export interface ReadOnlyRuleEdit extends IBaseRuleEdit {
	actions: List<ActionItem>;
}

export type RuleEdit = ReadonlyRecord<ReadOnlyRuleEdit>;

export const RuleEditFactory = Record<ReadOnlyRuleEdit>({
	actions: List(),
	name: null,
	id: null
});

export const RuleEditFactoryFromJS = function (data: IRuleEdit) {
	let actions: Array<ActionItem> = Array();

	if (data.actions && data.actions.length) {
		actions =
			data.actions && data.actions.length
				? data.actions.map(function (value: IActionItem) {
						return ActionItemFactoryFromJS(value);
				  })
				: [];
	}

	return RuleEditFactory({
		actions: List(actions),
		name: data.name,
		id: data.id
	});
};
